import { consumerThemeConfig } from '@jutro/theme-styles';

export const azJutroThemeConfig = {
    name: 'azJutroTheme',
    prefix: 'azJutroTheme',
    rootStyle: {
      ...consumerThemeConfig.rootStyle,
    //'--GW-SHADOW-1': '`38px` `15px` `5px` `0px` rgba(0, 0, 0, 0.75)',
    //'--GW-BACKGROUND-COLOR': '#000',
    '--GW-HEADER-BACKGROUND-COLOR': '#003781',
    '--GW-FOOTER-BACKGROUND-COLOR': '#ececec',
    '--GW-FIELD-COMPONENT-REQUIRED-SYMBOL-COLOR': '#c4221f',
    '--GW-FONT-SIZE-TRACKER-HEADER': '0.875rem',
    '--GW-FONT-SIZE-TRACKER-BODY': '0.875rem',
    //--GW-HEADER-LOGO-SIZE: 2.5rem;
    //--GW-HEADER-BACKGROUND-COLOR: var(--GW-BRAND-COLOR-2);

    },
  };